import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAreas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/suite-area', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArea(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/suite-area/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
